import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, Button, Tooltip, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import "./QuestionNavigation.css";

const QuestionNavigation = ({
  questions = [],
  currentQuestionId = null,
  onQuestionSelect,
  className = "",
}) => {
  const gridRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (!questions || questions.length === 0) return null;

  const isCurrentQuestion = (q) => currentQuestionId === q.id;
  // Show paddles when there are many questions (responsive threshold)
  const showPaddles = questions.length > (isMobile ? 5 : 7);

  const getStatus = (q) => {
    if (q.is_answered) return "answered";
    if (q.is_skipped) return "skipped";
    return "unanswered";
  };

  const scrollBy = (dx) => {
    gridRef.current?.scrollBy({ left: dx, behavior: "smooth" });
  };

  return (
    <Box
      className={`question-navigation ${
        showPaddles ? "show-paddles" : ""
      } ${className}`}
    >
      <Typography variant="overline" className="navigation-title">
        Questions
      </Typography>

      {/* navigation paddles (only visible when there are many questions) */}
      <IconButton
        className="nav-paddle left"
        size="small"
        aria-label="scroll questions left"
        onClick={() => scrollBy(-280)}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        className="nav-paddle right"
        size="small"
        aria-label="scroll questions right"
        onClick={() => scrollBy(280)}
      >
        <ChevronRight />
      </IconButton>

      <Box className="questions-grid" ref={gridRef}>
        {questions.map((q) => (
          <Tooltip
            key={q.id}
            title={
              <Box>
                <Typography variant="body2" className="tooltip-title">
                  Question {q.question_number}
                </Typography>
                <Typography variant="caption" className="tooltip-body">
                  {q.body?.length > 120
                    ? `${q.body.substring(0, 120)}…`
                    : q.body}
                </Typography>
              </Box>
            }
            arrow
            placement="top"
          >
            <Button
              className={`question-button ${getStatus(q)} ${
                isCurrentQuestion(q) ? "current" : ""
              }`}
              onClick={() => onQuestionSelect?.(q.id)}
              disabled={!!q.is_answered} // completed are disabled
              size="small"
              variant="text"
            >
              <span className="question-number">{q.question_number}</span>
              {q.has_subquestions && (
                <span
                  className="subquestion-indicator"
                  title="Has subquestions"
                >
                  •
                </span>
              )}
            </Button>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default QuestionNavigation;
